import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataGrid, {
  Column,
  Editing,
  Paging,
  FilterRow,
  Sorting,
  SearchPanel, // [추가] SearchPanel import
  Lookup,
  Toolbar,
  Item,
  Button,
} from 'devextreme-react/data-grid';
import 'devextreme/dist/css/dx.material.blue.light.css';
import API_URL from '../config';

export default function UserManager() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/oracle/users`);
      setUsers(res.data);
    } catch (err) {
      alert('사용자 데이터를 불러오는데 실패했습니다.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const onRowInserted = async (e) => {
    try {
      const postData = {
        ...e.data,
        // [수정] PASSWORD_HASH 대신 PASSWORD 필드로 전송
        PASSWORD: e.data.PASSWORD || '1234' // 비밀번호 미입력시 기본값
      };
      await axios.post(`${API_URL}/api/oracle/users`, postData);
      fetchUsers();
    } catch (err) {
      alert('사용자 등록에 실패했습니다.');
      console.error(err);
    }
  };

  const onRowUpdated = async (e) => {
    try {
      // DevExtreme은 변경된 데이터만 e.data에 담아줍니다.
      // 서버에서 undefined 필드는 무시하므로 그대로 전달해도 됩니다.
      console.log(e.key);
      await axios.put(`${API_URL}/api/oracle/users/${e.key}`, e.data);
      fetchUsers();
    } catch (err) {
      alert('사용자 수정에 실패했습니다.');
      console.error(err);
    }
  };

  const onRowRemoved = async (e) => {
    try {
      await axios.delete(`${API_URL}/api/oracle/users/${e.key}`);
      fetchUsers();
    } catch (err) {
      alert('사용자 삭제에 실패했습니다.');
      console.error(err);
    }
  };

  const roleList = [
    { id: 'ADMIN', name: '관리자' },
    { id: 'USER', name: '일반사용자' },
    { id: 'CUST', name: '고객사' },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>👤 사용자 관리</h2>
      <DataGrid
        dataSource={users}
        keyExpr="USER_ID"
        showBorders={true}
        columnAutoWidth={true}
        hoverStateEnabled={true}
        onRowInserted={onRowInserted}
        onRowUpdated={onRowUpdated}
        onRowRemoved={onRowRemoved}
        loading={loading}
      >
        <Editing
          mode="popup"
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
          popup={{
            title: '사용자 정보',
            showTitle: true,
            width: 500,
            height: 450, // 높이 조절
          }}
          form={{
            items: [
              {
                dataField: 'USER_ID',
                label: { text: '사용자 ID' },
              },
              {
                dataField: 'USER_NAME',
                label: { text: '사용자명' },
              },
              {
                dataField: 'EMAIL',
                label: { text: '이메일' },
              },
              {
                // [수정] dataField를 PASSWORD로 변경
                dataField: 'PASSWORD',
                label: { text: '비밀번호' },
                editorType: 'dxTextBox',
                editorOptions: {
                  // [수정] placeholder 텍스트 변경
                  placeholder: '새 비밀번호 (변경 시에만 입력)',
                  mode: 'password' // 비밀번호 안 보이게 처리
                }
              },
              {
                dataField: 'ROLE',
                label: { text: '권한' },
                editorType: 'dxSelectBox',
                editorOptions: {
                  dataSource: roleList,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  searchEnabled: true,
                },
              },
            ],
          }}
        />

        <Paging defaultPageSize={10} />
        <FilterRow visible={true} />
        <Sorting mode="multiple" />
        <SearchPanel visible={true} placeholder="검색..." />

        <Column dataField="USER_ID" caption="사용자 ID" allowEditingOnUpdate={false} />
        <Column dataField="USER_NAME" caption="사용자명" />
        <Column dataField="EMAIL" caption="이메일" />
        {/* [수정] 보안상 PASSWORD_HASH 컬럼은 그리드에 표시하지 않습니다. */}
        <Column dataField="ROLE" caption="권한">
          <Lookup
            dataSource={roleList}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>

        <Column type="buttons" width={110}>
          <Button name="edit" />
          <Button name="delete" />
        </Column>

        <Toolbar>
          <Item name="addRowButton" location="after" />
          <Item name="searchPanel" location="after" />
          <Item
            location="after"
            widget="dxButton"
            options={{
              icon: 'refresh',
              text: '새로고침',
              onClick: fetchUsers
            }}
          />
        </Toolbar>
      </DataGrid>
    </div>
  );
}